import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import enUS from './en-US.json'

/**
 * en-US only today, but the framework is wired up so a future locale
 * (es-MX, fr-CA) is an additive change, not a refactor. Inline JSX
 * strings are blocked by ESLint (see eslint.config.js) once we add
 * the rule in WEB-95 follow-up; for now, this scaffolding is what
 * unblocks every component that ships afterwards.
 *
 * Currency + dates go through `Intl.NumberFormat` / `Intl.DateTimeFormat`
 * directly, not through i18next — the runtime already handles locale.
 */

void i18n.use(initReactI18next).init({
  resources: {
    'en-US': { translation: enUS },
  },
  lng: 'en-US',
  fallbackLng: 'en-US',
  interpolation: { escapeValue: false },
})

export { i18n }
